export const changeLanguage = (val) => {
    return {
        type: 'CHANGE_LANGUAGE',
        payload: val
}}